import WorkshopScreenContainer from '../../features/containers/workshop/WorkshopScreenContainer';

export default function Visits() {
  return <WorkshopScreenContainer />;
}
